module.exports = __webpack_public_path__ + "static/media/thoughts.87193b0d.png";